// extracted by mini-css-extract-plugin
module.exports = {"EditDescription__edit-description__1tKMO":"EditDescription__edit-description__1tKMO","EditDescription__description-footer__7jMG5":"EditDescription__description-footer__7jMG5"};